import { render, staticRenderFns } from "./InstitucionesMapa.vue?vue&type=template&id=0edbc996&lang=pug&"
import script from "./InstitucionesMapa.vue?vue&type=script&lang=js&"
export * from "./InstitucionesMapa.vue?vue&type=script&lang=js&"
import style0 from "./InstitucionesMapa.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports